module.exports = __webpack_public_path__ + "img/finish.4ae5f694.png";